import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "v1-providers__list" }
const _hoisted_2 = { class: "v1-providers__logo" }
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListItem = _resolveComponent("ListItem")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("li", {
        key: item.key,
        class: _normalizeClass({ 'v1-providers__item--dimmed': item.dimmed })
      }, [
        _createVNode(_component_ListItem, {
          title: item.title,
          subtitle: item.subtitle || undefined,
          selected: _ctx.selectedKey === item.key,
          "data-testid": item.testId,
          onClick: ($event: any) => (_ctx.$emit('select', item.key))
        }, {
          leading: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, [
              _createElementVNode("img", {
                src: item.logoUrl,
                alt: item.title
              }, null, 8, _hoisted_3)
            ])
          ]),
          trailing: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(["v1-radio", { 'v1-radio--on': _ctx.selectedKey === item.key }]),
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 2
        }, 1032, ["title", "subtitle", "selected", "data-testid", "onClick"])
      ], 2))
    }), 128))
  ]))
}